import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import './MobileStep.css';

const MobileStep = ({ stepId, onClick, enabled, active }) => (
  <a onClick={() => (enabled ? onClick(stepId) : void null)}>
    <div className={ClassNames({ 'mobile-step': true, disabled: !enabled, active: active })} />
  </a>
);

MobileStep.propTypes = {
  enabled: PropTypes.bool,
  active: PropTypes.bool,
  stepId: PropTypes.string,
  onClick: PropTypes.func,
};

export default MobileStep;



// WEBPACK FOOTER //
// ./src/components/navigation/MobileStep.js